import React from "react";
import { default as WRadioGroup } from "@mui/material/RadioGroup";

function RadioGroup(props) {
  return <WRadioGroup {...props} />;
}

export default RadioGroup;
